import React from 'react';
import axios from 'axios';
import { Button, Modal, Form, Select, Input, InputNumber, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';
import globalFormItemLayout from 'components/Portal/formItemLayout'; 

class EditAwards extends React.Component {
	state = {
		visible: false,
		editingAward: null,
		award: {}
	}
	handleSelectAward = (award_id) => {
		this.setState({ editingAward: award_id });
		const award = this.props.financialAidTypes.find(award => award.id === award_id) || {};
		this.props.form.setFieldsValue({
			comments: award.comments,
			acceptLanguage: award.acceptLanguage,
			defaultTotal: award.defaultTotal
		});
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) return stickyError('Invalid input');
			axios.post(apiPath+'/financialaid/details', values, {withCredentials:true}).then(result => {
				this.props.isSubmitted();
				message.success('Saved!');
				this.props.onAwardUpdate();
			}).catch(error => stickyError('Error saving award details'));
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		return (
			<div style={{textAlign:'right'}}>
				<Button icon="edit" onClick={() => this.setState({visible:true})}>Edit Award Types</Button>
				<Modal visible={this.state.visible} title="Edit Award Types" closable={false} footer={[
					<Button onClick={() => this.setState({visible:false})}>Close</Button>
				]}>
					<Form onSubmit={this.handleSubmit}>
						<Form.Item label="Award">
							{getFieldDecorator('id', {})(
								<Select
									showSearch
									onChange={this.handleSelectAward}
									filterOption={(inputValue, option) => {
										if (option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) return true;
										if (option.key.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) return true;
										return false;
									}}>
									{this.props.financialAidTypes
										.sort((a,b) => a.description.localeCompare(b.description))
										.map(awardType =>
											<Select.Option key={awardType.id} value={awardType.id}>
												{awardType.description}
											</Select.Option>
										)
									}
								</Select>
							)}
						</Form.Item>
						{this.state.editingAward !== null &&
							<div>
								<Form.Item label="Default Award Amount">
									{getFieldDecorator('defaultTotal', {})(
										<InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
									)}
								</Form.Item>
								<Form.Item label="Acceptance Language">
									{getFieldDecorator('acceptLanguage', {
										// rules: [{max: 200, message: 'Too long (max 200 characters)'}]
									})(
										<Input.TextArea placeholder="Are you sure you want to accept this award?" />
									)}
								</Form.Item>
								<Form.Item label="Comments (internal)">
									{getFieldDecorator('comments', {
										rules: [{max: 200, message: 'Too long (max 200 characters)'}]
									})(
										<Input.TextArea />
									)}
								</Form.Item>
								<SaveButton
									disabled={!this.props.form.isFieldsTouched()}
									loading={this.props.getStatus().submitting} />
							</div>
						}
					</Form>
				</Modal>
			</div>
		);
	}
}

export default withSpin(Form.create()(EditAwards));



// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialAid/EditAwards.jsx